import * as React from 'react';
import { AppMenu } from '../../../components';
import { FormMenuItem } from './types';
const iPhone = require('./iPhone.png');

export const PhonePreview = ({ menuItem, imageUrl }: { menuItem: FormMenuItem; imageUrl?: string }) => {
  return (
    <div className='phone-content-container ms-4'>
      <img className='img-fluid' src={iPhone} />
      <div className='phone-content'>
        <AppMenu
          img={imageUrl || menuItem.item.imageUrl}
          price={menuItem.price}
          name={menuItem.item.name}
          description={menuItem.item.description}
        />
      </div>
    </div>
  );
};
